import { useEffect, useState } from "react"
import { useSearchParams } from "react-router-dom"
import axios from "axios"
import { Box, Typography, CircularProgress } from "@mui/material"

export default function SuccessPage() {
  const [params] = useSearchParams()
  const [details, setDetails] = useState(null)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    const fetchPaymentDetails = async () => {
      const invoiceId = params.get("invoice_id")
      try {
        const res = await axios.get(`/api/payment/details?invoiceId=${invoiceId}`)
        setDetails(res.data)
      } catch (err) {
        console.error("Error fetching payment details:", err)
      } finally {
        setLoading(false)
      }
    }
    fetchPaymentDetails()
  }, [])

  if (loading) return <CircularProgress />

  return (
    <Box p={4}>
      <Typography variant='h4' gutterBottom>
        🎉 Payment Successful!
      </Typography>
      <Typography variant='h6'>Thank you, {details.full_name}</Typography>
      <Typography>Email: {details.email}</Typography>
      <Typography>Phone: {details.phone}</Typography>
      <Typography>Amount Paid: ₪{details.amount}</Typography>
      <Typography>Invoice ID: {details.invoice_id}</Typography>
    </Box>
  )
}
